module.exports = __webpack_public_path__ + "static/quote@2x-ae65b8497e75574619f1d6eca353a849.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/cabify/quote@2x.jpg
// module id = 341
// module chunks = 3627797113349 20562973939449 33019919093843